import { cn } from "../../lib/utils";

/** Drop-in replacement for `<input type="checkbox">` wherever a setting needs a
 * pill-shaped on/off switch instead of a native checkbox square. */
export function ToggleSwitch({ checked, onChange, disabled, ariaLabel, className }: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative h-5 w-9 shrink-0 rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        checked ? "bg-brand" : "bg-line",
        className,
      )}
    >
      <span className={cn(
        "absolute top-0.5 h-4 w-4 rounded-full bg-elevated shadow-sm transition-all",
        checked ? "left-[18px]" : "left-0.5",
      )} />
    </button>
  );
}

/** Full labeled row (label + switch), same look the batch wizard already used. */
export function ToggleRow({ on, onClick, label, sub }: {
  on: boolean; onClick: () => void; label: string; sub?: string;
}) {
  return (
    <label className="flex items-center justify-between rounded-lg bg-soft px-4 py-3">
      <span>
        <span className="text-sm font-medium text-ink">{label}</span>
        {sub && <span className="block text-xs text-ink-3">{sub}</span>}
      </span>
      <ToggleSwitch checked={on} onChange={onClick} ariaLabel={label} />
    </label>
  );
}
